// extracted by css-extract-rspack-plugin
export default {"container":"ModelParameters-module__container__yfRcroQ"};